// extracted by mini-css-extract-plugin
module.exports = {"className":"zh-CN_className__9fWNJ"};